// import React from "react";
// import { Card, CardContent, Typography, Avatar, Divider, Box, Grid } from "@mui/material";
// import QRCode from "react-qr-code";
// import Moment from 'react-moment';
// import csjmusign from "../../assets/images/csjmusign.png";
// // import headerImage from '/src/assets/images/header.png';
// import header from "../../assets/images/header.png"




// type Student = {
//   name: string;
//   studentID: string;
//   dob: string;
//   department: string;
//   session: string;
//   mobile: string;
//   address: string;
//   image: string;
//   college: string;
//   collegefoot: string;
//   collegeLogo: string;
//   effctupto: string;
//   entry_dt: string;
//   efctv_dt: string;
//   email: string;
//   subject: string;
// };

// type StudentIDCardProps = {
//   students: Student[];
// };

// const IDCard: React.FC<StudentIDCardProps> = ({ students }) => {
//   return (
//     <Box sx={{
//       width: "full",
//       height: "auto",
//       overflow: "auto",
//       // display: "grid",
//       gridTemplateColumns: "1fr 1fr",
//       gap: 1,
//       p: 1,
//       bgcolor: "#f5f5f5",
//       "@media print": {
//         width: "100%",
//         height: "auto",
//         overflow: "hidden",
//         pageBreakInside: "avoid",
//         margin: "0mm",
//       },
//     }}>
//       {students.map((student, index) => (
//         <Grid container spacing={2} key={index}>
//           {/* Front Side */}
//           <Grid item xs={12} md={6} sm={6} lg={6}
//             style={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               marginBottom: 10
//             }}>
//             <Card
//               key={index}

//               sx={{
//                 width: "100mm",
//                 height: "70.5mm",
//                 borderRadius: 3,
//                 boxShadow: 3,
//                 bgcolor: "white",
//                 textAlign: "center",
//                 // p: 1,
//                 position: "relative", // ✅ Required for absolute positioning
//               }}
//             >
//               {/* <Box
//                 component="img"
//                 //src={student.collegeLogo}
//                 alt="Watermark Logo"
//                 sx={{
//                   position: "absolute",
//                   width: "80%",
//                   height: "80%",
//                   top: "10%",
//                   left: "10%",
//                   opacity: 0.15, // ✅ Light watermark effect
//                   zIndex: -1, // ✅ Keeps it behind content
//                   padding: 0
//                 }}
//               /> */}

//               {/* College Logo */}
//               <Grid container spacing={1} alignItems="center" sx={{ backgroundColor: "#ac1910" }}>
//                 <Grid item xs={3} textAlign="left">
//                   <Box sx={{ display: "flex", justifyContent: "center", mb: .5 }}>
//                     <Avatar src={header} alt="College Logo" sx={{ width: 50, height: 50 }} />
//                   </Box>
//                 </Grid>
//                 <Grid item xs={9} justifyContent="center">
//                   <Typography sx={{ fontSize: "9px" }} fontWeight="bold" color="white">
//                     {student.college}
//                   </Typography>
//                   <Typography sx={{ fontSize: "8px" }} fontWeight="bold" color="white">
//                     {student.collegefoot}
//                   </Typography>
//                 </Grid>
//               </Grid>
//               {/* <Divider sx={{ my: .5 }} /> */}

//               {/* Student Details Section */}

//               <Grid container spacing={1} alignItems="center" p={1} style={{
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "flex-start",
//                 backgroundImage: `url(${student.collegeLogo})`,
//                 backgroundSize: "22vh",
//                 backgroundRepeat: "no-repeat",
//                 backgroundPosition: "center center",
//                 // width: "100%",
//                 // height: "100%",
//                 // opacity: 1,

//               }}>
//                 <Grid item xs={12} textAlign="center" sx={{ opacity: 1 }} >
//                   <Typography variant="body2" style={{ color: "#0000FF" }}><b>Student ID Card</b> </Typography>
//                 </Grid>
//                 <Grid item xs={9} textAlign="left" sx={{ opacity: 1 }} style={{ marginBottom: 40 }}>

//                   <Grid container >
//                     <Grid item xs={4} >

//                       <Typography variant="body2" style={{ color: "#ac1910", fontSize: "11px" }}><b>Member ID</b></Typography>
//                       <Typography variant="body2" style={{ color: "#ac1910", fontSize: "11px" }}><b>Name</b> </Typography>
//                       {/* <Typography variant="body2"><b>Father`s Name</b> </Typography> */}

//                       <Typography variant="body2" style={{ color: "#ac1910", fontSize: "11px" }}><b>Course</b></Typography>
//                       <Typography variant="body2" style={{ color: "#ac1910", fontSize: "11px" }}><b>Department</b> </Typography>
//                       <Typography variant="body2" style={{ color: "#ac1910", fontSize: "11px" }}><b>Session/Batch</b> </Typography>
//                       <Typography variant="body2" style={{ color: "#ac1910", fontSize: "11px" }}><b>Phone No.</b> </Typography>
//                       <Typography variant="body2" style={{ color: "#ac1910", fontSize: "11px" }}><b>Valid Upto </b></Typography>
//                     </Grid>
//                     <Grid item xs={8} >
//                       <Typography variant="body2" style={{ fontSize: "11px" }}><b>: {student.studentID}</b></Typography>
//                       <Typography variant="body2" style={{ fontSize: "11px" }}><b>: {student.name}</b></Typography>
//                       {/* <Typography variant="body2"><b>: {student.name}</b></Typography> */}

//                       {/* <Typography variant="body2"><b>: {student.session}</b></Typography> */}
//                       <Typography variant="body2" style={{ fontSize: "11px" }}><b>: {student.session}</b></Typography>
//                       <Typography variant="body2" style={{ fontSize: "11px" }}><b>:{student.department}</b></Typography>
//                       <Typography variant="body2"><b>:{' '}
//                         <Moment format="YYYY">
//                           {student.efctv_dt}
//                         </Moment> -
//                         <Moment format="YY">
//                           {student.entry_dt}
//                         </Moment>
//                       </b></Typography>
//                       <Typography variant="body2" style={{ fontSize: "11px" }}><b>: {student.mobile} </b></Typography>
//                       <Typography variant="body2" style={{ fontSize: "11px" }}><b>: <Moment format="DD/MM/YYYY">
//                         {student.effctupto}
//                       </Moment></b></Typography>

//                     </Grid>
//                   </Grid>


//                 </Grid>
//                 {/* Student Image */}
//                 <Grid item xs={3} style={{ marginBottom: 30 }}>
//                   <Avatar src={student.image} alt={student.name} sx={{ width: 90, height: 95, border: "2px solid #1976d2" }} />
//                   <img src={csjmusign} height={30} ></img>
//                   <Typography variant="body2"><b>Chief Proctor</b></Typography>
//                 </Grid>
//               </Grid>

//               <Divider sx={{ my: -2 }} />
//               <Grid container spacing={1} alignItems="center" sx={{ bgcolor: "blue" }}>
//                 <Grid item xs={3} textAlign="left">
//                   {/* QR Code */}
//                   {/* <Box sx={{ display: "flex", justifyContent: "left", mt: .2 }}>
//             <QRCode value={student.studentID} size={40} />
//           </Box> */}
//                 </Grid>
//                 <Grid item xs={9} textAlign="right" >
//                   <Typography variant="caption" height={20} sx={{ display: "block", mt: .2 }}>
//                     {/* Issuing Authority: Librarian */}
//                   </Typography>
//                 </Grid>
//               </Grid>

//             </Card>
//           </Grid>

//           {/* Back Side */}
//           <Grid item xs={12} md={6} sm={6} lg={6}>
//             <Card sx={{ width: "100mm", height: "70.5mm", borderRadius: 3, boxShadow: 3, bgcolor: "white", }}>
//               <Grid container spacing={1} alignItems="center" sx={{ backgroundColor: "#ac1910" }}>


//                 <Grid item xs={12} textAlign="center">
//                   <Typography sx={{ fontSize: "9px" }} fontWeight="bold" color="white">
//                     {student.college}
//                   </Typography>
//                   <Typography sx={{ fontSize: "8px" }} fontWeight="bold" color="white">
//                     {student.collegefoot}
//                   </Typography>
//                 </Grid>
//               </Grid>


//               <Divider />
//               <Typography variant="body2" marginLeft={1}><b>Additional Information :</b> </Typography>
//               <Grid container spacing={1} alignItems="center" p={.5} >
//                 <Grid item xs={12} textAlign="left" sx={{ opacity: 1, marginLeft: 2 }} >
//                   {/* <div style={{ backgroundImage: `url(${student.collegeLogo})`, backgroundSize: "contain", backgroundRepeat: "no-repeat", backgroundPosition: "center",opacity: 0.2 }}> */}
//                   <Typography variant="body2" >       <span style={{ color: "#0000FF" }}><b>Email ID :</b></span> {student.email}</Typography>
//                   <Typography variant="body2">       <span style={{ color: "#0000FF" }}><b>Address :</b></span>{student.address}</Typography>

//                   {/* <Typography variant="body2"><b>DOB:</b> <Moment format="DD/MM/YYYY">
//               {student.dob}
//             </Moment></Typography> */}


//                   {/* </div> */}
//                 </Grid>
//               </Grid>
//               <Typography variant="body2" marginLeft={1}><b>Important Instructions : </b> </Typography>
//               <Typography variant="body2" marginLeft={2} sx={{ textAlign: "left", fontSize: "10px", justifyContent: "center" }}>
//                 1) The entry will be restricted to Indentity Cardholders Only. <br />
//                 2) To avail of any kind of facilities or services, an Identity card is mandatory.<br />
//                 3) This card is the property of C.S.J.M.U. Kanpur. In case the card is lost/found it should be informed to the Librarian Immediately.<br />
//                 4) A duplicate Identity card will be issued on the payment of Rs 150/-.<br />
//                 5) An Identity card is non transferable to other people to avail of any kind of services of CSJMU Kanpur.
//               </Typography>

//               {/* <Divider sx={{ my: .1 }} /> */}
//               <Box textAlign="right">
//                 <QRCode value={student.studentID} size={45} style={{ marginRight: 4, paddingBottom: 10 }} />
//               </Box>
//             </Card>
//           </Grid>
//         </Grid>
//       ))}
//     </Box>
//   );
// };

// export default IDCard;








import React from "react";
import { Card, CardContent, Typography, Avatar, Divider, Box, Grid } from "@mui/material";
import QRCode from "react-qr-code";
import Moment from 'react-moment';
import csjmusign from "../../assets/images/csjmusign.png";
import header from "../../assets/images/header.png";

type Student = {
  name: string;
  studentID: string;
  dob: string;
  department: string;
  session: string;
  mobile: string;
  address: string;
  image: string;
  college: string;
  collegefoot: string;
  collegeLogo: string;
  effctupto: string;
  entry_dt: string;
  efctv_dt: string;
  email: string;
  subject: string;
};

type StudentIDCardProps = {
  students: Student[];
};

const IDCard: React.FC<StudentIDCardProps> = ({ students }) => {
  return (
    <Box sx={{
      width: "100%",
      height: "auto",
      overflow: "auto",
      p: 1,
      bgcolor: "#f5f5f5",
      "@media print": {
        width: "100%",
        height: "auto",
        overflow: "hidden",
        pageBreakInside: "avoid",
        margin: "0mm",
      },
    }}>
      {students.map((student, index) => (
        <Grid container spacing={2} key={index} sx={{
          justifyContent: "center",
          "@media (max-width: 600px)": {
            flexDirection: "column",
            alignItems: "center",
          }
        }}>
          {/* Front Side */}
          <Grid item xs={12} md={6} sm={6} lg={6}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: 2,
              "@media (max-width: 600px)": {
                width: "100%",
                maxWidth: "100mm",
              }
            }}>
            <Card
              sx={{
                width: "100mm",
                height: "70.5mm",
                borderRadius: 3,
                boxShadow: 3,
                bgcolor: "white",
                textAlign: "center",
                "@media (max-width: 600px)": {
                  width: "100%",
                  maxWidth: "100mm",
                  height: "auto",
                  minHeight: "70.5mm"
                }
              }}
            >
              <Grid container spacing={1} alignItems="center" sx={{ backgroundColor: "#ac1910" }}>
                <Grid item xs={3} textAlign="left">
                  <Box sx={{ display: "flex", justifyContent: "center", mb: 0.5 }}>
                    <Avatar src={header} alt="College Logo" sx={{ width: 50, height: 50 }} />
                  </Box>
                </Grid>
                <Grid item xs={9} justifyContent="center">
                  <Typography sx={{ fontSize: "9px" }} fontWeight="bold" color="white">
                    {student.college}
                  </Typography>
                  <Typography sx={{ fontSize: "8px" }} fontWeight="bold" color="white">
                    {student.collegefoot}
                  </Typography>
                </Grid>
              </Grid>

              <Grid container spacing={1} alignItems="center" p={1} sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                backgroundImage: `url(${student.collegeLogo})`,
                backgroundSize: "22vh",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center center",
                "@media (max-width: 600px)": {
                  backgroundSize: "15vh",
                }
              }}>
                <Grid item xs={12} textAlign="center" sx={{ opacity: 1 }} >
                  <Typography variant="body2" style={{ color: "#0000FF" }}><b>Student ID Card</b> </Typography>
                </Grid>
                <Grid item xs={9} textAlign="left" sx={{ opacity: 1 }} style={{ marginBottom: 40 }}>
                  <Grid container>
                    <Grid item xs={4}>
                      <Typography variant="body2" style={{ color: "#ac1910", fontSize: "11px" }}><b>Member ID</b></Typography>
                      <Typography variant="body2" style={{ color: "#ac1910", fontSize: "11px" }}><b>Name</b> </Typography>
                      <Typography variant="body2" style={{ color: "#ac1910", fontSize: "11px" }}><b>Course</b></Typography>
                      <Typography variant="body2" style={{ color: "#ac1910", fontSize: "11px" }}><b>Department</b> </Typography>
                      {(student.department.length > 32) && <Typography variant="body2" style={{ color: "#ac1910", fontSize: "11px", marginBottom: "17px" }}><b></b> </Typography>}
                      <Typography variant="body2" style={{ color: "#ac1910", fontSize: "11px" }}><b>Session/Batch</b> </Typography>
                      <Typography variant="body2" style={{ color: "#ac1910", fontSize: "11px" }}><b>Phone No.</b> </Typography>
                      <Typography variant="body2" style={{ color: "#ac1910", fontSize: "11px" }}><b>Valid Upto </b></Typography>
                    </Grid>
                    <Grid item xs={8}>
                      <Typography variant="body2" style={{ fontSize: "11px" }}><b>: {student.studentID}</b></Typography>
                      <Typography variant="body2" style={{ fontSize: "11px" }}><b>: {student.name}</b></Typography>
                      <Typography variant="body2" style={{ fontSize: "11px" }}><b>: {student.session}</b></Typography>
                      <Typography variant="body2" style={{ fontSize: "11px" }}><b>:{student.department}</b></Typography>
                      <Typography variant="body2">
                        <b>:{' '}
                          <Moment format="YYYY">
                            {student.efctv_dt}
                          </Moment>-<Moment format="YY">
                            {student.effctupto}
                          </Moment>
                        </b>
                      </Typography>
                      <Typography variant="body2" style={{ fontSize: "11px" }}><b>: {student.mobile} </b></Typography>
                      <Typography variant="body2" style={{ fontSize: "11px" }}><b>: <Moment format="DD/MM/YYYY">
                        {student.effctupto}
                      </Moment></b></Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={3} style={{ marginBottom: 30 }}>
                  <Avatar src={student.image} alt={student.name} sx={{
                    width: 90,
                    height: 95,
                    border: "2px solid #1976d2",
                    "@media (max-width: 600px)": {
                      width: 70,
                      height: 75
                    }
                  }} />
                  <img src={csjmusign} height={30} alt="Signature" />
                  <Typography variant="body2"><b>Chief Proctor</b></Typography>
                </Grid>
              </Grid>

              <Divider sx={{ my: -2 }} />
              <Grid container spacing={1} alignItems="center" sx={{ bgcolor: "blue" }}>
                <Grid item xs={3} textAlign="left"></Grid>
                <Grid item xs={9} textAlign="right">
                  <Typography variant="caption" height={20} sx={{ display: "block", mt: 0.2 }}>
                  </Typography>
                </Grid>
              </Grid>
            </Card>
          </Grid>

          {/* Back Side */}
          <Grid item xs={12} md={6} sm={6} lg={6}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              "@media (max-width: 600px)": {
                width: "100%",
                maxWidth: "100mm",
              }
            }}>
            <Card sx={{
              width: "100mm",
              height: "70.5mm",
              borderRadius: 3,
              boxShadow: 3,
              bgcolor: "white",
              "@media (max-width: 600px)": {
                width: "100%",
                maxWidth: "100mm",
                height: "auto",
                minHeight: "70.5mm"
              }
            }}>
              <Grid container spacing={1} alignItems="center" sx={{ backgroundColor: "#ac1910" }}>
                <Grid item xs={12} textAlign="center">
                  <Typography sx={{ fontSize: "9px" }} fontWeight="bold" color="white">
                    {student.college}
                  </Typography>
                  <Typography sx={{ fontSize: "8px" }} fontWeight="bold" color="white">
                    {student.collegefoot}
                  </Typography>
                </Grid>
              </Grid>

              <Divider />
              <Typography variant="body2" marginLeft={1}><b>Additional Information :</b> </Typography>
              <Grid container spacing={1} alignItems="center" p={0.5}>
                <Grid item xs={12} textAlign="left" sx={{ opacity: 1, marginLeft: 2 }}>
                  <Typography variant="body2">       <span style={{ color: "#0000FF" }}><b>Email ID :</b></span> {student.email}</Typography>
                  <Typography variant="body2">       <span style={{ color: "#0000FF" }}><b>Address :</b></span>{student.address}</Typography>
                </Grid>
              </Grid>
              <Typography variant="body2" marginLeft={1}><b>Important Instructions : </b> </Typography>
              <Typography variant="body2" marginLeft={2} sx={{
                textAlign: "left",
                fontSize: "10px",
                justifyContent: "center",
                "@media (max-width: 600px)": {
                  fontSize: "9px"
                }
              }}>
                1) The entry will be restricted to Indentity Cardholders Only. <br />
                2) To avail of any kind of facilities or services, an Identity card is mandatory.<br />
                3) This card is the property of C.S.J.M.U. Kanpur. In case the card is lost/found it should be informed to the Librarian Immediately.<br />
                4) A duplicate Identity card will be issued on the payment of Rs 150/-.<br />
                5) An Identity card is non transferable to other people to avail of any kind of services of CSJMU Kanpur.
              </Typography>

              <Box textAlign="right">
                <QRCode value={student.studentID} size={45} style={{ marginRight: 4, paddingBottom: 10 }} />
              </Box>
            </Card>
          </Grid>
        </Grid>
      ))}
    </Box>
  );
};

export default IDCard;
